import React from 'react';
import { ChevronDown } from 'lucide-react';

interface Concept2CollapsibleSectionProps {
  title: string;
  icon?: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const Concept2CollapsibleSection: React.FC<Concept2CollapsibleSectionProps> = ({
  title,
  icon,
  open,
  onToggle,
  children,
}) => (
  <section className="overflow-hidden rounded-lg border border-border bg-surface">
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left"
      aria-expanded={open}
    >
      <span className="flex items-center gap-2 text-sm font-semibold text-content-primary">
        {icon}
        {title}
      </span>
      <ChevronDown
        className={`h-4 w-4 text-content-muted transition-transform ${open ? 'rotate-180' : ''}`}
        aria-hidden
      />
    </button>
    {open && <div className="border-t border-border px-4 py-4">{children}</div>}
  </section>
);

export default Concept2CollapsibleSection;
